const initialState = { p1: false, p2: false, p3: false};

export default function phases(state = initialState, action) {
  switch (action.type) {
    case "SET_PHASE": {
      return {
        ...state,
        [`p${action.phase}`]: action.value
      };
    }
  }
  return state;
}